import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../ui/Tooltip';
import { LAYOUT_PRESETS } from './terminalLayoutPresets';
import LayoutThumbnail from './LayoutThumbnail';

/**
 * The preset tiles in the Layouts ▾ menu. `disabled` (a locked AI tab)
 * keeps them visible but inert, with a tooltip saying why.
 */
export default function LayoutPresetGrid({ disabled, onApply }) {
  const { t } = useTranslation();
  return (
    <div className="term-preset-grid">
      {LAYOUT_PRESETS.map((p) => (
        <Tooltip key={p.id} content={disabled ? t('terminalExt.aiTabNoSplit', 'The AI tab runs approved commands only and cannot be split') : t(p.labelKey, p.label)} side="bottom">
          <button
            type="button"
            className="term-preset"
            role="menuitem"
            aria-disabled={disabled ? 'true' : undefined}
            onClick={() => !disabled && onApply(p)}
          >
            <LayoutThumbnail tree={p.build(Array.from({ length: p.slots }, (_, i) => `x${i}`))} />
            <span>{t(p.labelKey, p.label)}</span>
          </button>
        </Tooltip>
      ))}
    </div>
  );
}
